// Sales, karta kontaktu na celou stránku (telefon a odkazy z Kontaktů a Zkušebních).
import React from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import KartaKontaktu from "../../components/sales/KartaKontaktu.jsx";

export default function SalesKontakt() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { poZmene } = useOutletContext();
  const zpet = () => (window.history.length > 1 ? navigate(-1) : navigate("/sales/dnes"));
  return (
    <div className="mx-auto w-full max-w-3xl">
      <KartaKontaktu key={id} id={Number(id)} onZmena={poZmene} onZpet={zpet} />
    </div>
  );
}
